<!-- mainified_representative_quality  && unmainified_representative_quality -->
<template>
  <div class="modal fade slide-right" id="mainifyModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-sm">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <i class="pg-close fs-14"></i>
                      </button>
                      <h5>Définir {{newMainRepresentative.person.first_name}} {{newMainRepresentative.person.last_name}} en tant que représentant principal à la place de:
                        {{previousRepresentative.person.first_name}} {{previousRepresentative.person.last_name}}
                      </h5>
                  </div>
                  <div class="modal-body"  >
                        <resource-form :model="form.model" :schema="form.schema" :triggers="form.triggers" :submit-button='false' :hub='hub' :dropdownParent="'#mainifyModal'"
                        >
                        </resource-form>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-primary btn-cons pull-left inline" data-dismiss="modal" @click="hub.$emit('submit-click')" >
                          Confirmer
                      </button>
                      <button type="button" class="btn btn-default btn-cons no-margin pull-left inline"
                              data-dismiss="modal" @click="$emit('cancel')">Annuler
                      </button>
                  </div>
              </div>
          </div>
          <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
  </div>
</template>

<script>
  import ResourceForm from "components/Forms/ResourceForm"

  import Vue from 'vue'

    export default {

      name: 'MainifyModal',

      props: ['newMainRepresentative', 'previousRepresentative', 'form'],

      components: {
        ResourceForm,
      },

      data () {
        return {
          hub: new Vue(),
          // model: {
          //   mainified_representative_quality:null,
          //   unmainified_representative_quality:null,
          // },
        }
      },

        mounted () {
            $(this.$el).modal()
            this.hub.$on("my-submit", (model) => {
              this.$emit('mainify', this.newMainRepresentative.representative_id, model)
            })
        },

        beforeDestroy () {
            this.hub.$off("submit")
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },

    }
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// client/components/Customer/RepresentativesContent/MainifyModal.vue